export class ImpoundTypeApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes(params) {
    return this.#http.get('/api/impound-types', { params });
  }

  async createType(body) {
    return this.#http.post('/api/impound-types', body);
  }

  async editType({ impoundTypeId, ...body }) {
    return this.#http.put(`/api/impound-types/${impoundTypeId}`, body);
  }

  async deleteType({ impoundTypeId }) {
    return this.#http.delete(`/api/impound-types/${impoundTypeId}`);
  }
}
